import { Box, Button, Dialog, PopOver } from './'

export const PopUpMenu = ({ open, onClose, items, ...props }) => (<>
  <PopOver
    className="desktop-only"
    items={items}
    open={open}
    onClose={onClose}
    {...props}
  />
  <Dialog
    className="mobile-only"
    open={open}
    showControls={false}
    onClose={(e) => {
      onClose()
      e.stopPropagation()
    }}
  >
    <Box column gap={16} fullWidth>
      {items.map((item, index) =>
        <Button
          fullWidth
          key={index}
          onClick={(e) => {
            e.stopPropagation()
            item.onClick(e)
            onClose()
          }}
        >
          {item.text}
        </Button>
      )}
    </Box>
  </Dialog>
</>)
